import * as React from 'react';
import { Link } from 'react-router-dom';
import { ShipToAddressRead } from '../../../../shared/models/ship-to-address-read';
import { ChiTooltip } from '../../../../components/utility/ChiTooltip';
import { Routes } from '../../../../utils/app-constants';

interface IProps {
    address: ShipToAddressRead;
    onClick: (address: ShipToAddressRead) => void;
}

export const AddressReviewRow = (props: IProps) => {

    const itm = props.address;
    const orderIds = itm.orderIds ?? [];

    return (
        <tr onClick={() => props.onClick(itm)}>
            <td>
                <Link to={{
                    pathname: `${Routes.APPROVALS_ADDRESSES}/${itm.id}`,
                    state: itm
                }}>
                    {itm.name ? itm.name : ''}
                </Link>
            </td>
            <td>{itm.customerId}</td>
            <td>{(itm.address && itm.address.addressLine1) ? itm.address.addressLine1 : ''}</td>
            <td>{(itm.address && itm.address.city) ? itm.address.city : ''}</td>
            <td>{(itm.address && itm.address.stateProvince) ? itm.address.stateProvince : ''}</td>
            <td>{(itm.address && itm.address.country) ? itm.address.country : ''}</td>
            <td>{itm.isJobSite ? 'X' : ''}</td>
            <td>
                {orderIds.length > 0 ? (
                    <ChiTooltip
                        title={'Pending Orders'}
                        body={<p>The following orders use this address and require address review: {orderIds.join(', ')}</p>}
                        content={
                            <span style={{ textDecoration: 'underline dotted', cursor: 'help' }}>
                                {orderIds.length} order{orderIds.length === 1 ? '' : 's'}
                            </span>
                        }
                    />
                ) : (
                    ''
                )}
            </td>
            <td>{itm.reviewUser ? '✓' : ''}</td>
        </tr>
    );
};
